import { type ReactElement } from 'react';
import { Micro } from '@/components/atoms/micro';
import { cn } from '@/lib/cn';
import type { Mood } from '@/lib/types';

type MoodOption = {
  value: Mood;
  label: string;
};

const MOOD_OPTIONS: MoodOption[] = [
  { value: 'OFF', label: 'Off' },
  { value: 'MEH', label: 'Meh' },
  { value: 'GOOD', label: 'Good' },
  { value: 'FLOW', label: 'Flow' },
];

type MoodPickerProps = {
  currentMood: Mood | null;
  onSelect: (mood: Mood | null) => void;
};

export function MoodPicker({ currentMood, onSelect }: MoodPickerProps): ReactElement {
  return (
    <div role="group" aria-label="How did it feel?">
      <Micro className="mb-3">Mood</Micro>
      <div className="flex gap-3">
        {MOOD_OPTIONS.map(({ value, label }) => {
          const isSelected = currentMood === value;
          return (
            <button
              key={value}
              type="button"
              aria-pressed={isSelected}
              onClick={() => onSelect(isSelected ? null : value)}
              className={cn(
                'flex-1 py-3 rounded-[var(--r-sm)] text-xs font-bold transition-all',
                'focus:outline-none focus-visible:ring-2 focus-visible:ring-[var(--brand)]',
                'focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--bg-surface)]',
                isSelected
                  ? 'bg-[var(--brand)] text-white border border-[var(--brand)]'
                  : 'bg-[var(--bg-soft)] border border-[var(--rule)] text-[var(--ink)] hover:border-[var(--brand)]',
              )}
            >
              {label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
